import { createAction } from '@reduxjs/toolkit';

export const changeFilter = createAction('contact/changeFilter');
